var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-2"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","lg":"6"}},[_c('Markets',{on:{"rowSelected":function($event){return _vm.rowSelected($event)}}})],1),_c('v-col',{attrs:{"cols":"12","lg":"6"}},[_c('MarketSubstances',{attrs:{"MktID":_vm.mktId}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }